import type { State } from '../../reducer.tsx';

export const isSpinnerVisible = (state: State, id: string) => state.ui.delete.spinner[id];

export const componentsBeingDeleted = (state: State): string[] =>
	state.ui.delete.componentsBeingDeleted;
